import React from "react";
import { observer } from "mobx-react-lite";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { betPeriods } from "@utils/common/BetPeriods";

export default observer(function DepositPeriodsFilterSection() {
	const { register } = useFormContext();

	const { t } = useTranslation("payment");

	return (
		<div className="form__group">
			<label htmlFor="periodSelect" className="label">
				{t<string>("FILTER_FORM.SELECT_PERIOD")}
			</label>
			<select
				id="periodSelect"
				className="input input--med input--select"
				{...register("period")}
			>
				{betPeriods.map((betPeriod) => (
					<option key={betPeriod.value} value={betPeriod.value}>
						{t<string>(`FILTER_FORM.PERIODS.${betPeriod.name}`)}
					</option>
				))}
			</select>
		</div>
	);
});
